import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const TransitionContext = createContext(null);
export const usePageTransition = () => useContext(TransitionContext);

export const PageTransitionProvider = ({ children }) => {
  const [active, setActive] = useState(false);
  const [phase, setPhase] = useState(0);
  const navigateRef = useRef(null);
  const activeRef = useRef(false);

  const navigateWithTransition = useCallback((path) => {
    if (activeRef.current) return;
    activeRef.current = true;
    setActive(true);
    setPhase(0);

    setTimeout(() => setPhase(1), 50);
    setTimeout(() => setPhase(2), 400);
    setTimeout(() => {
      if (navigateRef.current) navigateRef.current(path);
    }, 700);
    setTimeout(() => setPhase(3), 900);
    setTimeout(() => {
      activeRef.current = false;
      setActive(false);
      setPhase(0);
    }, 1300);
  }, []);

  return (
    <TransitionContext.Provider value={{ navigateWithTransition, navigateRef }}>
      {children}
      {active && (
        <div
          className="fixed inset-0 z-[9998] flex items-center justify-center pointer-events-none"
          style={{
            backgroundColor: phase >= 3 ? 'transparent' : '#0a0a0a',
            opacity: phase === 0 ? 0 : phase >= 3 ? 0 : 1,
            transition: phase >= 3 ? 'opacity 0.35s ease-out' : 'opacity 0.25s ease-in',
          }}
        >
          <div
            style={{
              opacity: phase >= 1 && phase < 3 ? 1 : 0,
              transform: phase >= 1 ? 'scale(1)' : 'scale(0.85)',
              transition: 'all 0.35s cubic-bezier(0.16, 1, 0.3, 1)',
            }}
          >
            <img
              src="/logo.png"
              alt="BestCars"
              width="160"
              height="64"
              decoding="async"
              className="h-14 sm:h-16"
            />
          </div>
        </div>
      )}
    </TransitionContext.Provider>
  );
};

export const NavigateRegistrar = () => {
  const navigate = useNavigate();
  const { navigateRef } = usePageTransition();
  navigateRef.current = navigate;
  return null;
};
